import React from 'react'

//components
import Results from '../../components/STRUCTURE_MIGRATION/search/Results'

function Index() {
    return (
        <main id="search_main">
            <section id="searchBanner">
                <div className="wrapper">
                    <h1>
                        Търсене на учебни материали
                    </h1>
                    <p>
                        Lorem Ipsum е елементарен примерен текст, използван в печатарската и типографската индустрия.
                    </p>
                </div>
            </section>
            <Results />
        </main>
    )
}

export default Index